// extracted by mini-css-extract-plugin
export default {"box":"featureBox_box__jOkrz","boxTitle":"featureBox_boxTitle__hh9UF","boxDescription":"featureBox_boxDescription__0-JxN"};